export { default } from "./details-sections";
